import { Component, Input, ViewChild } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';

@Component({
    selector: 'create-demand-form-entry',
    templateUrl: './demand-form-entry.component.html',
    styleUrls: ['./demand-form-entry.component.scss'],
    standalone: false
})
export class DemandFormEntryComponent {
    @ViewChild('labelElement') public labelEl!: HTMLLabelElement;

    @Input() control!: AbstractControl;
    @Input() label!: string;
    @Input() hasError!: boolean;
    @Input() saveSpaceForErrorMsg = true;
    @Input() errorMsg!: string;
    @Input() emptyValue: any = '';
    @Input() required = false;
    @Input() hideInputGroupElements = false;
    @Input() maxStrLength?: number;

    public get hasRequiredValidator(): boolean {
        return this.control.hasValidator(Validators.required);
    }
}
